import {useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';

import FormError from 'components/form/Error';
import FormSubmit from 'components/form/Submit';
import FormText from 'components/form/Text';
import {handleSubmitErrors} from 'components/form/utils';
import useAppContext from 'conf/AppContext';
import './UpdatePassword.scss';


export default function UpdatePassword({userId}) {
  const appContext = useAppContext();
  const [message, setMessage] = useState(null);

  const formMethods = useForm({
    defaultValues: {
      newPassword: '',
      confirmNewPassword: '',
      userId,
    },
  });

  const {handleSubmit, setError} = formMethods;

  const onSubmit = async (values) => {
    try {
      const rez = await appContext.api.post('api/v1/users/resetpassword/reset', {
        json: values,
        parseJson: true,
      });
      setMessage(rez?.message);
    } catch (err) {
      await handleSubmitErrors(appContext, err, setError);
    }
  };

  return (
    <div className="updatePasswordPage">
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <h3 className="text-center mb-5">Update your password</h3>
          {message && <h4 className="text-success text-center mb-3">{message}</h4>}
          <FormText
            label="New Password"
            name="newPassword"
            required={true}
            type="password"
          />

          <FormText
            label="Confirm New Password"
            name="confirmNewPassword"
            required={true}
            type="password"
          />

          <div className="text-center mt-3">
            <FormError />
            <FormSubmit
              key="save"
              className="btn btn-lg btn-outline-light bg-black text-white"
            >
              Update Password
            </FormSubmit>
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
